import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=5dc75aa8&scoped=true&lang=pug&"
import script from "./StatusBar.vue?vue&type=script&lang=js&"
export * from "./StatusBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=5dc75aa8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc75aa8",
  null
  
)

component.options.__file = "StatusBar.vue"
export default component.exports